export default "__VITE_ASSET__QH7xH9el__"